//"Anniversaires, aventures, moments cool… ajoutez tout ça dans votre calendrier !"
fx.ns("desktop.calendar.panels", class CalendarEventsPanel extends fx.Component {
    constructor(model) {
        super();

        this.data = model;

        this.listenUpdates(this.data.creation);
    }


    create() {
        super.create();

        // events screen
        this.eventsScreen = new fx.components.Box("events-screen");

        this.descriptionBlock = new fx.components.Box("description-block");
        this.descriptionBlock.effect = "fade";
        this.description = new fx.components.Text({ text: fx.text("Ajoutez un événement en sélectionnant une date dans le calendrier."), className: "description" });
        this.descriptionBlock.addChild(this.description, { left: 0, top: 0, width: "100%" });
    
        this.eventsScreen.addChild(this.descriptionBlock, { top: "30%", left: "center", height:100, width: "90%" });
        
        this.listEvents = new fx.components.VBox("list-events");
        this.eventsScreen.addChild(this.listEvents, { top: 0, bottom: 0, height: "fill", width: "100%" });

        this.addChild(this.eventsScreen, { width: "100%", height: "100%", top: 0, left: 0 });


    }

    onReady() {
        super.onReady();

        this._buildEvents();

        this.on("click", this.onEditDate, this.listEvents);

    }

    
    onEditDate(e) {
        let obj = fx.dom.parent(e.target, ".day-box");
        if (obj) {
            let dayBox = this.listEvents.getChild(obj.id);
            if (dayBox)
                dayBox.data.event("select-event-calendar", {page : dayBox.page, day : dayBox.attr("day")});
        }
    }

    onChildUpdated(action) {
        if (action.model instanceof models.CreationElementContent) {
            if (action.impacts("content")) { this._buildEvents(); }
        }
    }

    _buildEvents() {

        if (!this.initialized)
            return;

        this.listEvents.removeAllChild();

        let containsDate = false;
        for (let i = 0; i < this.data.creation.dates.length; i++) {
            let month = this.data.creation.dates[i];

            let monthLabel = new fx.components.Text({ text: month.label, className: "month-label" });

            if (month.dates.length > 0)
                this.listEvents.addChild(monthLabel);

            
            for (let j = 0; j < month.dates.length; j++) {

                containsDate = true;
                let date = month.dates[j];

                let dayBox = new fx.components.Box("day-box");
                dayBox.attr("month", month.month);
                dayBox.attr("day", date.day);
                dayBox.attr("year", month.year);
                dayBox.data = month.component;
                dayBox.page = month.element;

                let button = new fx.components.Image({ data: fx.assets.editIcon, className: "edit" });

                let container = new fx.components.VBox("day-container");
                let dayLabel = new fx.components.Text({ text: Date.normalize(date.day) + " " + month.monthLabel, className: "day-label" });
                let dayEvent = new fx.components.Text({ text: date.event, className: "day-event" });

                container.addChild(dayLabel, { width: "100%" });
                container.addChild(dayEvent, { width: "100%" });

                dayBox.addChild(container, { width: "80%", left: 0 });
                dayBox.addChild(button, { width: 40, height: 40, right: 10, top: 10 });

                this.listEvents.addChild(dayBox, { left: "center", width: "90%" });
            }
        }

        this.descriptionBlock.toggle(!containsDate);
    }
});